<template>
  <div
    class="vip"
    :id="activity618 ? 'activity618' : ''"
    v-if="vipTypeList.length"
    v-buried
    :data-buried="BuriedData.BG_SALE_VIP"
  >
    <div class="vip-top">
      <AppNavbar :options="options" :zIndex="999" :title="title">
        <div slot="right">
          <span class="explain iconfont icon-help" @click="bindExplain"></span>
        </div>
      </AppNavbar>
      <img class="logo" :src="logoImage" alt="" />
      <!-- 用户信息 -->
      <div class="user-info">
        <!-- logo -->
        <img
          class="flag"
          v-if="!activity618"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1bc0e13e1c3a642a7f5400cf8fa89cae.png"
          alt=""
        />
        <div class="u-top">
          <img class="avatar" :src="userInfo && userInfo.head_img" alt="" />
          <div class="u-t-right">
            <div class="nickname">{{ userInfo && userInfo.truename }}</div>
            <div class="desc">您还不是WE+会员哦，升级立享多项专业权益</div>
          </div>
        </div>
      </div>
      <div v-if="vipTypeList.length" class="vip-content">
        <div class="v-type-scroll">
          <div class="v-type-list">
            <div
              class="v-type-item-content"
              v-for="(item, index) in vipTypeList"
              :key="index"
              @click="bindChangeType(index)"
            >
              <div v-if="item.red" class="red">{{ item.red }}</div>
              <div v-if="item.type_id == recommendType">
                <img class="less-200" :src="flagImage" alt="" />
              </div>
              <div
                class="v-type-item"
                v-buried
                v-clickBuried
                :data-click-buried="BuriedData.CLICK_VIP_TYPE[item.type_id]"
                :data-buried="BuriedData.BG_VIP_TYPE[item.type_id]"
                :class="{
                  'v-type-item-large': item.type_id == recommendType,
                  'v-type-item-mid': item.type_id == secondRecommendType,
                  'v-type-item-active': index == curType
                }"
              >
                <div class="mask"></div>
                <div class="name">{{ item.name }}</div>
                <div class="desc" v-if="item.desc" v-html="item.desc"></div>
                <div class="v-flex-1"></div>
                <div class="cur-price"
                  ><span class="cur-unit">¥</span>{{ item.real_price }}</div
                >
                <div class="original-price"
                  ><span class="o-price">¥{{ item.price }}</span>
                  <span class="tips" v-if="index == 0"
                    >仅{{ item.day_price }}元/天</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="buy-btn">
          <div
            v-show="index == curType"
            v-for="(item, index) in vipTypeList"
            :key="index"
            class="buy-btn"
            id="buy-btn"
            @click="bindBuyVip('top')"
            v-buried
            :data-buried="
              BuriedData.BG_VIP_OPEN_UP[vipTypeList[curType].type_id]
            "
            v-clickBuried
            :data-click-buried="
              BuriedData.CLICK_VIP_OPEN_UP[vipTypeList[curType].type_id]
            "
          >
            开通{{ vipTypeOptions[vipTypeList[curType].type_id] }}卡</div
          >
        </div>
        <div class="protocol" :class="{ 'check-wobble': wobble }"
          ><span
            class="check"
            :class="{ 'check-active': readProtocol }"
            @click="bindProtocol"
            ><span class="iconfont icon-gou" v-show="readProtocol"></span></span
          ><span>我已阅读并同意</span
          ><span class="text" @click="bindToAgreement">会员服务协议</span></div
        >
        <!-- plus会员 -->
        <div
          class="vip-plus-content"
          v-if="config.is_open_banner"
          v-buried
          :data-buried="BuriedData.BG_VIPPLUS_YEAR"
          v-clickBuried
          :data-click-buried="BuriedData.CLICK_VIPPLUS_YEAR"
        >
          <img
            class="plus-image"
            :src="plusImage"
            alt=""
            @click="bindBuyPlus"
          />
        </div>
      </div>
      <!-- 权益 -->
      <div class="right-list">
        <div v-for="(item, index) in vipRightImage" :key="index">
          <div v-show="vipTypeList[curType].type_id == item.id">
            <div v-for="(item1, index1) in item.list" :key="index1">
              <img class="right-title" :src="item1.title" alt="" />
              <!-- 会员专属权益表格 -->
              <img
                class="right-table"
                v-if="item1.type == 'table'"
                :src="item1.data"
                alt=""
              />
              <!-- 反馈 -->
              <div class="feedback" v-if="item1.type == 'feedback'">
                <div class="swiper my-swiper" id="my-swiper">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(feedbackitem, feedbackindex) in feedbackData"
                      :key="feedbackindex"
                    >
                      <div class="feedback-item">
                        <img
                          class="feedback-image"
                          :src="feedbackitem"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 权益详情 -->
              <div v-if="item1.type == 'list'">
                <div
                  class="right-detail"
                  v-for="(rightItem, rightIndex) in item1.data"
                  :key="rightIndex"
                  v-buried
                  :data-buried="[
                    BuriedData.BG_VIP_LIST[rightItem.id][
                      vipTypeList[curType].type_id
                    ],
                    BuriedData.BG_VIP_LIST[rightItem.id].all
                  ]"
                  v-clickBuried
                  :data-click-buried="[
                    BuriedData.CLICK_VIP_LIST[rightItem.id][
                      vipTypeList[curType].type_id
                    ],
                    BuriedData.CLICK_VIP_LIST[rightItem.id].all
                  ]"
                  @click="bindDetail(item, rightIndex)"
                >
                  <img class="right-image" :src="rightItem.image" alt="" />
                  <img
                    class="r-detail-index"
                    :src="rightIndexImages[rightIndex]"
                    alt=""
                  />
                  <div class="r-detail"
                    ><span>查看详情</span><span class="iconfont icon-you"></span
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="btm-buy-btn"
        :class="{ 'btm-buy-btn-fixed': isFixedBuy }"
        :style="{ paddingBottom: (bottomBarHeight || 20) + 'px' }"
      >
        <!-- 跑马灯 -->
        <PaoMaDeng class="paomadeng" :speed="120">
          <img
            :src="item"
            class="paomadeng-item"
            v-for="(item, index) in paomadengData"
            :key="index"
            alt=""
          />
        </PaoMaDeng>
        <div class="protocol" :class="{ 'check-wobble': wobble }"
          ><span
            class="check"
            :class="{ 'check-active': readProtocol }"
            @click="bindProtocol"
            ><span class="iconfont icon-gou" v-show="readProtocol"></span></span
          ><span>我已阅读并同意</span
          ><span class="text" @click="bindToAgreement">会员服务协议</span></div
        >
        <div class="buy-content">
          <div class="consult-btn" @click="bindConsult">
            <div class="iconfont icon-kefuicon"></div>
            <div class="text">咨询客服</div>
          </div>
          <div
            class="buy-btn"
            v-show="index == curType"
            v-for="(item, index) in vipTypeList"
            :key="index"
            @click="bindBuyVip('bot')"
            v-buried
            :data-buried="
              BuriedData.BG_VIP_OPEN_DOWN[vipTypeList[curType].type_id]
            "
            v-clickBuried
            :data-click-buried="
              BuriedData.CLICK_VIP_OPEN_DOWN[vipTypeList[curType].type_id]
            "
          >
            <div class="b-buy-left">
              <span class="b-buy-unit">¥</span
              ><span class="b-buy-num">{{
                vipTypeList[curType].real_price
              }}</span
              ><span class="b-buy-time"
                >/{{ vipTypeOptions[vipTypeList[curType].type_id] }}</span
              >
            </div>
            <div class="b-buy-text"> 开通会员 </div>
          </div>
        </div>
      </div>
    </div>
    <AppLoading v-if="isLoading" class="loading"></AppLoading>
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper-bundle.min.css'
import PaoMaDeng from '@/components/paomadeng.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import {
  vipTypeOptions,
  vipRightImage,
  rightIndexImages,
  feedbackData,
  paomadengData,
  BuriedData
} from './data'
export default {
  components: {
    AppNavbar,
    PaoMaDeng,
    AppLoading
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      config: {},
      BuriedData,
      rightIndexImages, //vip权益序号图片
      vipRightImage, //vip权益图片信息
      feedbackData, //反馈数据
      paomadengData, //跑马灯数据
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgb(255,255,255)'
      },
      vipTypeOptions, //vip类型id
      title: '',
      vipTypeList: [],
      curType: 0,
      isFixedBuy: false, //是否固定购买按钮
      readProtocol: false,
      wobble: false, //会员协议勾选框是否晃动
      bottomBarHeight: 0, //底部安全区域高度
      recommendType: 3, //当前推荐会员卡类型
      secondRecommendType: 2, //次推荐会员卡类型
      redType: 3, //哪个vip类型上有标签
      activity618: false,
      isLoading: false
    }
  },
  computed: {
    flagImage() {
      return this.activity618
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a60c6faebad8b5d927d51c5ec777a89b.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2023-05-24-betterwe-vip-right-icon'
    },
    logoImage() {
      return this.activity618
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c058a2c5bc0fcdf27030a1a4bbc6b5bb.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1e8c161588149e73a45d287111d7f552.png'
    },
    plusImage() {
      return this.activity618
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/64a8847bd9497c610dfed951c35073a0.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7c7c90c4e53ae539a965530c799efac7.png'
    },
    plusBuyUrl() {
      return this.activity618
        ? 'http://t.weimob.com/AQ_CI43'
        : 'http://t.weimob.com/dHXns'
    }
  },
  created() {
    this.getTabBar()
    this.getVipList()
    this.getConfig()
  },
  mounted() {
    this.addScrollEvent()
    this.addLog('大会员购买页曝光')
    setTimeout(() => {
      console.dir(document.getElementsByClassName('v-type-item')[0])
    }, 200)
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    autoBuryPoint() {
      let list = [
        {
          cssSelector: '.auto-exp-component',
          positionSelector: '',
          logkey: 'WKSUM_SHOW_FINISH', // 事件管理中的事件id
          props: [] // 你要曝光的元素身上自定义属性
        }
      ]
      this.$autoBuryPoint(list)
    },
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('.my-swiper', {
          loop: true,
          autoplay: {
            disableOnInteraction: false,
            delay: 3000
          },
          slidesPerView: 2.08,
          loopedSlides: 4,
          autoHeight: true,
          //方法事件
          on: {
            //回调函数，swiper从当前slide开始过渡到另一个slide时执行
            slideChange: function () {
              //self.activeIndex = this.activeIndex
            }
          }
        })
      })
    },
    //跳转购买plus年卡
    bindBuyPlus() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=' + this.plusBuyUrl + '&title=商城'
        )
      }
    },
    /**
     * 埋点
     */
    addLog(from) {
      this.$http
        .getApp('member/StorageLogin/spotLog', { from, type: 3 })
        .then((res) => {})
    },
    bindExplain() {
      this.$router.push('/betterwe/vip-explain')
    },
    bindProtocol() {
      this.readProtocol = !this.readProtocol
    },
    bindBuyVip(type) {
      if (!this.readProtocol) {
        this.$toast('请先阅读并同意会员服务协议')
        this.wobble = true
        setTimeout(() => {
          this.wobble = false
        }, 500)
        return
      }
      this.bindShop()
      this.$buryPoint('CLICK_BUYVIP', {})
      this.addLog('大会员点击开通-' + type)
    },
    //去商城
    async bindShop() {
      if (this.$http._isApp()) {
        let id = this.vipTypeList[this.curType].type_id
        let buyUrl = ''
        let data = this.vipRightImage.find((item) => {
          return item.id == id
        })
        if (!data) {
          this.$toast('未找到会员类型')
          return
        }
        this.isLoading = true
        let res = await this.$http
          .getApp('api/v1/WeplusUserCenter/getConfig', {})
          .catch(() => {})
        this.isLoading = false
        if (res && res.data.code == 200) {
          this.config = res.data.data
          if (this.config.is_jump_shop && this.config.url) {
            let env = this.$http.curEv()
            let shopId = data.betterweShopUrl[env].dtid
            let goodsId = data.betterweShopUrl[env].id
            let typeId = this.vipRightImage.findIndex((item) => {
              return item.id == id
            })
            buyUrl =
              this.config.url +
              '&id=' +
              goodsId +
              '&dtid=' +
              shopId +
              '&salesman_id=' +
              (typeId + 1)
            this.$betterwe.onAppCloseRoute()
            // this.$parent.addEventUserInfo && this.$parent.addEventUserInfo();
            this.$betterwe.onAppPageUrlRoute(
              '/web?url=' + encodeURIComponent(buyUrl) + '&title=购买大会员'
            )
          } else {
            buyUrl = data.buyUrl
            buyUrl &&
              this.$betterwe.onAppPageUrlRoute(
                '/wmOtherPage?fromType=11&url=' + buyUrl + '&title=商城'
              )
          }
        } else {
          this.$toast('异常错误')
        }
      }
    },
    getConfig() {
      this.$http
        .getApp('api/v1/WeplusUserCenter/getConfig', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.config = res.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //联系客服
    bindConsult() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          `/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url= https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fa5b3ae4ebbaa2707bcb11489bdb668c1.jpg&title=添加陪伴官`
        )
      }
    },
    bindToAgreement() {
      this.$router.push('/betterwe/vip-agreement')
    },
    bindDetail(item, index) {
      this.$router.push({
        path: '/betterwe/vip-detail',
        query: {
          id: item.id,
          index: index,
          activity618: +this.activity618
        }
      })
    },
    getActivityStatus(time) {
      let now = new Date(+time * 1000).getTime()
      let left = new Date('2023/06/12 00:00:00').getTime()
      let right = new Date('2023/06/19 00:00:00').getTime()
      if (now >= left && now <= right) {
        this.activity618 = true
      }
    },
    //获取vip分类列表
    getVipList() {
      this.$http
        .getApp('api/v1/WeplusUserCenter/getAllSellCard', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.getActivityStatus(res.time)
            let data = res.data
            data = data.filter((item) => {
              return (
                (item.card_type_first_level || 0) == 0 &&
                (item.card_type_second_level || 0) == 0
              )
            })
            //排序根据推荐会员类型排序
            data.sort((a, b) => {
              if (a.type_id == this.recommendType) {
                return -1
              } else if (b.type_id == this.recommendType) {
                return 1
              }
            })
            data = data.map((item, index) => {
              item.price = parseFloat(item.price)
              item.real_price = parseFloat(item.real_price)
              if (item.type_id == this.recommendType) {
                item.desc = this.activity618
                  ? '送 <span style="font-weight:600">价值868元减脂礼包</span>'
                  : '人均瘦<span style="font-weight:600">4.5</span>斤'
                this.curType = index
              }
              if (item.type_id == this.redType) {
                item.red = this.activity618 ? '买一得四' : '爆款热销'
              }
              if (item.type_id == this.secondRecommendType) {
                item.red = '超值推荐'
              }
              if (this.activity618 && item.type_id == 3) {
                item.name = '超燃年卡'
              }
              return item
            })
            this.vipTypeList = data
            this.$store.commit('betterweVip/setSellCard', data)
            this.initSwiper()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let dom = document.getElementById('buy-btn')
      if (dom) {
        let scrollTop =
          e.target.documentElement.scrollTop ||
          e.target.body.scrollTop ||
          e.target.pageYOffset
        let offsetTop = dom.offsetTop
        if (scrollTop > offsetTop) {
          //不在屏幕内
          this.isFixedBuy = true
        } else {
          this.isFixedBuy = false
        }
        if (scrollTop >= 100) {
          this.title = 'WE+减脂会员'
          this.options = {
            barBackgroundColor: 'rgba(255, 255, 255, 1)',
            color: '#000'
          }
        } else {
          this.title = ''
          let p = parseFloat((scrollTop / 100).toFixed(2))
          this.options = {
            barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
            color: '#fff'
          }
        }
      }
    },
    bindChangeType(index) {
      this.curType = index
    },
    async getTabBar() {
      let res = await this.$betterwe.getAppBarHeight().catch(() => {})
      if (res) {
        this.bottomBarHeight = res.bottomBarHeight
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './activity618.scss';

.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.vip {
  background: #f7f7f7;
  overflow: hidden;
  @include paddingBottom(195px);

  .explain {
    font-size: 24px;
  }

  .vip-top {
    position: relative;
    overflow: hidden;
    z-index: 1;
    background-color: rgba(19, 17, 23, 1);
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/adfdb721ca6dba0af4b963037c9cb25e.png'),
      url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8436d7a14241858934d19a5788b851e7.png');
    background-repeat: no-repeat;
    background-position: center top, center;
    background-size: contain;
    margin-bottom: -18px;
  }

  .logo {
    position: absolute;
    top: 47px;
    left: 37px;
    height: 16px;
    object-fit: contain;
  }

  .user-info {
    width: 353px;
    height: 155px;
    margin: 0px auto;
    box-sizing: border-box;
    margin-top: 90px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2023-05-24-betterwe-vip-user-bg');
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    z-index: -1;

    .flag {
      width: 150px;
      height: 151px;
      object-fit: contain;
      position: absolute;
      right: -11px;
      top: -60px;
    }

    .b-image {
      position: absolute;
      width: 100vw;
      left: 50%;
      top: 84px;
      transform: translate(-50%, 0%);
      z-index: 0;
    }

    .u-top {
      display: flex;
      align-items: center;
      padding: 13px 16px 11px;
      box-sizing: border-box;

      .avatar {
        border-radius: 50%;
        overflow: hidden;
        width: 42px;
        height: 42px;
        margin-right: 10px;
        object-fit: cover;
      }

      .u-t-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .nickname {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #deceb6;
          line-height: 16px;
          margin-bottom: 6px;
        }

        .desc {
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(241, 224, 197, 0.8);
          line-height: 14px;
        }
      }
    }
  }

  .vip-content {
    margin-top: -70px;
    padding-top: 40px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8436d7a14241858934d19a5788b851e7.png');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100%;

    .vip-plus-content {
      padding: 0px 16px 0px;
      box-sizing: border-box;
      margin-bottom: 30px;

      .plus-image {
        width: 100%;
        /*  height: 112px;
        object-fit: contain; */
      }
    }

    .v-type-scroll {
      padding: 16px;
      box-sizing: border-box;
      overflow-y: scroll;
    }

    .v-type-list {
      display: inline-flex;
      align-items: flex-start;

      .v-type-item-content {
        position: relative;
        margin-right: 12px;

        .red {
          position: absolute;
          left: -3px;
          top: 0;
          line-height: 24px;
          transform: translate(0%, -40%);
          height: 24px;
          width: 65px;
          text-align: center;
          background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/74a14ab6e06639ee3c663d3eec2a4115.png');
          background-repeat: no-repeat;
          background-size: contain;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          z-index: 3;
        }

        .less-200 {
          position: absolute;
          right: 0px;
          top: 0px;
          width: 49px;
          height: auto;
          z-index: 1;
          object-fit: contain;
        }
      }

      .v-type-item {
        position: relative;
        z-index: 1;
        width: 82px;
        height: 156px;
        box-sizing: border-box;
        border-radius: 8px;
        padding: 19px 0px 25px;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        text-align: center;

        .mask {
          position: absolute;
          z-index: -1;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background: #312d31;
          box-shadow: inset 0px 1px 2px 0px rgba(115, 106, 106, 0.62),
            inset 0px -2px 3px 0px rgba(108, 107, 107, 0.29);
          border-radius: 8px;
        }

        .name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(225, 225, 225, 0.7);
          line-height: 16px;
        }

        .desc {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.8);
          line-height: 15px;

          .bold {
            margin: 0 2px;
            font-size: 17px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #ffffff;
            line-height: 14px;
          }
        }

        .v-flex-1 {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }

        .cur-price {
          font-size: 22px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #e1e1e1;
          line-height: 12px;
          margin-bottom: 7px;

          .cur-unit {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            line-height: 11px;
            margin-right: 3px;
          }
        }

        .original-price {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #949499;
          line-height: 16px;

          .o-price {
            text-decoration: line-through;
          }

          .tips {
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffe598;
            line-height: 16px;
            margin-left: 4px;
          }
        }

        .circle {
          display: none;
        }
      }

      .v-type-item-mid {
        width: 120px;

        .cur-price {
          font-size: 36px;
          font-family: DINPro-Bold, DIN;
        }
      }

      .v-type-item-active {
        .mask {
          box-sizing: border-box;
          height: calc(100% + 7px);
          border: 12px solid transparent;
          border-bottom: 20px solid transparent;
          border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c9f9ce339f6918a7d20770e5d83b6ba3.png');
          border-image-slice: 24 24 40 24 fill;
          background: none;
          box-shadow: none;
        }

        .name {
          font-weight: 600;
          color: #ffffff;
        }

        .cur-price {
          color: #ffe598;

          .cur-unit {
            color: #ffe598;
          }
        }

        .circle {
          display: block;
          position: absolute;
          left: 50%;
          bottom: -9px;
          border-radius: 0px 0px 4px 0px;
          transform: translate(-50%, 0%) rotateZ(45deg) skew(-6deg, -6deg);
          width: 14px;
          height: 14px;
          background-color: #fff2e8;
          border-bottom: 2.5px solid #e29c80;
          border-right: 2.5px solid #e29c80;
          box-sizing: border-box;
          z-index: 30;
        }
      }

      .v-type-item-large {
        text-align: left;
        width: 137px;
        padding-left: 12px;
        padding-right: 12px;
        padding-bottom: 25px;
        position: relative;
        z-index: 0;

        .name {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 16px;
          margin-bottom: 6px;
        }

        .cur-price {
          font-size: 36px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          line-height: 18px;

          .cur-unit {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            line-height: 18px;
          }
        }
      }

      .v-type-item-content:last-child {
        margin-right: 0;
      }
    }

    .buy-btn {
      border-radius: 27px;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c600aa0fe3e3d8901f0f2abffdbea459.png');
      background-repeat: no-repeat;
      background-size: contain;
      /* border: 2px solid transparent;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(to bottom, #C2986A 0%, #F8E0BD 19%, #EED2A5 55%, #BD9962 100%), linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(244, 215, 156, 1)); */
      text-align: center;
      width: 335px;
      height: 47px;
      margin: 0 auto 10px;
      line-height: 47px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202020;
      letter-spacing: 1px;
    }

    .protocol {
      font-size: 12px;
      text-shadow: 0px 5px 9px rgba(0, 0, 0, 0.09);
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 16px;
      margin-bottom: 30px;

      .check {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255, 234, 173, 0.8);
        box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.09);
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-weight: 600;
          font-size: 8px;
          color: #111;
        }
      }

      .check-active {
      }

      .text {
        color: rgba(208, 190, 142, 1);
        text-decoration: underline;
      }
    }
  }

  .right-list {
    overflow: hidden;
    background-color: #f7f7f7;
    border-radius: 20px 20px 0 0;
    background-clip: padding-box, content-box;
    padding-top: 25px;
    background-repeat: repeat-y;
    background-size: 100%;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f99260037edd4f5e7f34c1e8b8483a87.png');
    background-position: center 25px;

    .right-title {
      margin: 0 auto 22px;
      width: 232px;
      height: 19px;
      object-fit: contain;
    }

    .right-table {
      width: 347px;
      margin: 0 auto 40px;
    }

    .right-detail {
      position: relative;
      width: 343px;
      margin: 0 auto 16px;
    }

    .right-image {
      width: 100%;
    }

    .r-detail-index {
      height: 16px;
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translate(-50%, 0%);
    }

    .r-detail {
      position: absolute;
      right: 16px;
      top: 50px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d1972f;
      line-height: 16px;
      display: inline-flex;
      align-items: center;

      .iconfont {
        margin-left: 4px;
        font-weight: 600;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
        border: 1px solid #d1972f;
        border-radius: 50%;
        font-size: 9px;
        text-align: center;
        line-height: 10px;
      }
    }

    .feedback {
      margin-bottom: 40px;

      ::v-deep .van-swipe {
        overflow: visible;
      }

      .feedback-item {
        width: 162px;
        height: 164px;

        .feedback-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .swiper {
      .swiper-slide-active {
        .feedback-item {
          margin-left: 16px;
        }
      }

      .swiper-slide-next {
        .feedback-item {
          margin: 0px 10px;
        }
      }
    }
  }

  .btm-buy-btn {
    width: 100%;
    padding: 12px 16px 0px;
    box-sizing: border-box;

    .paomadeng {
      position: absolute;
      top: -38px;
      left: 0;
      z-index: 10;

      .paomadeng-item {
        min-width: 147px;
        height: 22px;
        object-fit: contain;
        margin-right: 10px;
      }
    }

    .consult-btn {
      color: #000;

      .iconfont {
        font-size: 22px;
        margin-bottom: 4px;
      }

      .text {
        line-height: 14px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
      }
    }

    .protocol {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      display: flex;
      align-items: center;
      line-height: 16px;
      margin-bottom: 19px;

      .check {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 8px;
        box-sizing: border-box;
        border: 1px solid #999;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-size: 8px;
          color: #fff;
        }
      }

      .check-active {
        border: 1px solid rgba(255, 234, 173, 1);
        background: rgba(255, 234, 173, 1);
      }

      .text {
        color: rgba(220, 187, 99, 1);
        text-decoration: underline;
      }
    }

    .buy-content {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .buy-btn {
      width: 284px;
      height: 47px;
      border-radius: 24px;
      line-height: 47px;
      display: flex;
      align-items: center;
      box-shadow: 0px 5px 9px 0px rgba(237, 187, 154, 0.26);
      background: linear-gradient(
        110deg,
        #606044 0%,
        #1f1f30 60%,
        rgba(255, 227, 173, 1) 60%,
        rgba(238, 210, 126, 1) 100%
      );

      .b-buy-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: clip;
        padding-left: 24px;
        text-align: left;

        .b-buy-unit {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffeaad;
          line-height: 16px;
          margin-right: 2px;
        }

        .b-buy-num {
          font-size: 32px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #ffeaad;
        }

        .b-buy-desc {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffdab8;
          line-height: 16px;
        }

        .b-buy-time {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffeaad;
          line-height: 16px;
          margin-right: 4px;
        }
      }

      .b-buy-text {
        width: 110px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #202020;
        line-height: 16px;
      }
    }
  }

  .btm-buy-btn-fixed {
    position: fixed;
    left: 0;
    bottom: 0px;
    z-index: 10;
    background-color: #fff;
  }

  .check-wobble {
    animation: wobble 0.3s linear;
  }

  @keyframes wobble {
    0% {
      transform: translate(0px, 0px);
    }

    20% {
      transform: translate(-1px, 4px);
    }

    40% {
      transform: translate(3px, 0px);
    }

    60% {
      transform: translate(4px, 4px);
    }

    80% {
      transform: translate(-2px, -1px);
    }

    100% {
      transform: translate(2px, 0px);
    }
  }
}
</style>
